module.exports = __webpack_public_path__ + "static/media/tra_sem_sta.90c12805.png";